/**
 * 渲染组件类型
 */
export const RENDER_TYPE = {
  /** 子包 */
  SUB: 'sub',
  /** 自定义组件 */
  CUSTOM: 'custom',
};

// 主视图id
export const RootViewId = 'home-main-root';

// 无数据兜底
export const PreheatTempID = 'mach_pro_sailor_c_area_preheat';

// 无更多数据: 无下拉更多数据时前端自动拼接
export const NoMoredataTempID = 'mach_pro_sailor_c_no_more_data_mach_custom';

// cid
export const pageCid = 'c_waimai_c_overseas_uvyhshpd';

/// 无数据兜底样式
export const PreheatItemDefaultData = {
  component_id: PreheatTempID,
  component_properties: {
    render_type: RENDER_TYPE.CUSTOM
  },
  layout_info: {},
  json_data: {
    sceneCode: 0,
    message: ''
  }
};

/**
 * 异常code码
 */
export enum HOME_PAGE_ERROR_CODE {
  PRE_PAGE_LOGIN_CODE = 201003221, // 预热页面-已登录
  PRE_PAGE_NO_LOGIN_COE = 201003222, // 预热页面-未登录
  LOGIN_CODE = 201003216, // 未开城-已登录
  NO_LOGIN_CODE = 201003217, // 未开城-未登录
  NO_SUPPLY_AREA = 201003206, // 无供给
  NO_DATA = 201003207, // 无数据
  NO_SERVICE = 201003213, // 不在服务范围：pageInfo接口在用
  LOADING = 20230505, // 加载中
}

export const HomePageEmptyImgMapping = {
  201003206: 'http://img-ap-hongkong.mykeeta.net/sailorc/d68605c40bc28693a4d073c50ab64ef19478.png',
  201003207: 'http://img-ap-hongkong.mykeeta.net/sailorc/d68605c40bc28693a4d073c50ab64ef19478.png',
  20230505: '',
};

export const HomePgaeLodaingItemData = {
  component_id: PreheatTempID,
  component_properties: {
    render_type: RENDER_TYPE.CUSTOM
  },
  layout_info: {},
  json_data: {
    sceneCode: HOME_PAGE_ERROR_CODE.LOADING, // 加载中
    message: ''
  }
};

export const HomePgaeFirstLoadingShopListData = {
  module_body: {
    component_list: [HomePgaeLodaingItemData]
  }
};

export const KEY_REFRESH_FAVORITE_INFO = 'refresh_favorite_info';
